import { type FC } from "react";
import { TextLink } from "@root/shared/components/TextLink";
import { Button } from "@root/shared/components/Button";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import * as style from "./styles.css";

const BUSINESS_TYPE_CONFIG: Record<string, { imageSrc: string; imageAlt: string; label: string }> =
  {
    biyoshi: {
      imageSrc: "/images/user_frontend/landing/assessment/keyvisual_biyoshi.png",
      imageAlt: "美容師業界向け売上力診断のイラスト",
      label: "美容師業界で働く",
    },
    eyelist: {
      imageSrc: "/images/user_frontend/landing/assessment/keyvisual_eyelist.png",
      imageAlt: "アイリスト業界向け売上力診断のイラスト",
      label: "アイリスト業界で働く",
    },
  };

const DEFAULT_CONFIG = {
  imageSrc: "/images/user_frontend/landing/assessment/keyvisual.png",
  imageAlt: "ランキングでわかる売上力診断のイラスト",
  label: "美容業界で働く",
};

type Props = {
  totalCount: number;
  rejobPath: string;
  onClickNextStep: () => void;
  businessType: string | null;
  showCampaignBanner: boolean;
};

export const AssessmentStart: FC<Props> = ({
  totalCount,
  rejobPath,
  onClickNextStep,
  businessType,
  showCampaignBanner,
}) => {
  const config =
    businessType && BUSINESS_TYPE_CONFIG[businessType]
      ? BUSINESS_TYPE_CONFIG[businessType]
      : DEFAULT_CONFIG;
  const { imageSrc, imageAlt, label } = config;

  return (
    <section className={style.outer}>
      <img
        src={imageSrc}
        alt={imageAlt}
        width="390"
        height="209"
        loading="lazy"
        className={style.keyVisual}
      />
      <p className={style.totalCountOuter}>
        {businessType ? <span className={style.totalCountLabelBlock}>{label}</span> : label}
        <span className={`${style.totalCount} ${style.coloredText}`}>{totalCount}</span>
        人のデータから診断中！
      </p>
      <div className={showCampaignBanner ? style.containerCampaign : style.container}>
        <div className={style.inner}>
          {showCampaignBanner ? (
            <>
              <LazyLoadImage
                src="/images/user_frontend/landing/assessment/amazon-gift-campaign-banner-balloon.png"
                width={328}
                height={68}
                alt="診断結果をシェアすると抽選でAmazonギフト券1000円分が当たる"
              />
              <div className={style.buttonOuter}>
                <Button
                  theme="primary"
                  onClick={onClickNextStep}
                  data-ga-action="assess_input__start"
                >
                  3分で完了！診断をはじめる
                </Button>
              </div>
            </>
          ) : (
            <>
              <p className={style.minuteText}>
                ＼<span className={style.coloredText}>3分</span>で完了／
              </p>
              <div className={style.buttonOuter}>
                <Button
                  theme="primary"
                  onClick={onClickNextStep}
                  data-ga-action="assess_input__start"
                >
                  診断をはじめる
                </Button>
              </div>
            </>
          )}
        </div>
        <p className={style.annotation}>
          現在準備中のため、
          <br />
          すでに会員の方は診断を受けることができません。
          <br />
          今後の機能追加にご期待ください。
        </p>
        <p className={style.textLinkOuter}>
          <TextLink href={rejobPath}>リジョブを見る</TextLink>
        </p>
      </div>
    </section>
  );
};
